import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/primitives/dialog";
import { Button } from "@repo/ui/primitives/button";
import { SetupRoadmapPanel } from "@/components/common/SetupRoadmapPanel.jsx";

export function SetupGuideModal({ open, onClose }) {
  const { t } = useTranslation("setupGuide", { useSuspense: false });
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-[min(1120px,96vw)] w-full p-0 gap-0 max-h-[92vh] flex flex-col"
        showCloseButton={false}
      >
        <DialogHeader className="sr-only">
          <DialogTitle>{t("title", { defaultValue: "Setup Roadmap" })}</DialogTitle>
          <DialogDescription>{t("subtitle", { defaultValue: "Setup roadmap" })}</DialogDescription>
        </DialogHeader>
        <div className="relative overflow-hidden bg-white">
          <div className="absolute right-3 top-3 z-20 flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="text-foreground/70 hover:text-foreground hover:bg-neutral-50 font-semibold text-xs rounded-lg px-3 py-1.5 h-auto bg-white border border-neutral-200"
            >
              {t("close", { defaultValue: "Close" })}
            </Button>
          </div>
          <SetupRoadmapPanel
            compact
            embedded
            onNavigate={(path) => {
              onClose();
              navigate(path);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
